import React, { useState, lazy } from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, MessageCircleIcon, SendIcon, CheckCircleIcon } from 'lucide-react';
import { Button } from '../components/Button';
export function ContactUs() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Here you would typically send the form data to your backend
    console.log('Form submitted:', formState);
    // Show success message
    setIsSubmitted(true);
    // Reset form
    setFormState({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
  };
  return <main className="py-16 w-full bg-[#F9FAFB]" data-id="element-891">
      <div className="container mx-auto px-4" data-id="element-892">
        <div className="text-center mb-12" data-id="element-893">
          <h1 className="text-4xl font-bold mb-4" data-id="element-894">Contact Us</h1>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-895">
            Our team is here to help. Reach out to us with any questions about
            our eSIM services, and we'll get back to you as soon as possible.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16" data-id="element-896">
          {/* Contact Information */}
          <div className="lg:col-span-1" data-id="element-897">
            <div className="bg-white rounded-xl shadow-sm p-8 h-full" data-id="element-898">
              <h2 className="text-2xl font-bold mb-6" data-id="element-899">Get in Touch</h2>
              <div className="space-y-6" data-id="element-900">
                <div className="flex items-start" data-id="element-901">
                  <div className="bg-blue-100 p-3 rounded-lg mr-4" data-id="element-902">
                    <MapPinIcon className="h-6 w-6 text-[#2563EB]" data-id="element-903" />
                  </div>
                  <div data-id="element-904">
                    <h3 className="font-semibold text-lg mb-1" data-id="element-905">Our Office</h3>
                    <p className="text-gray-600" data-id="element-906">
                      123 Travel Street, Suite 100
                      <br data-id="element-907" />
                      Dubai, United Arab Emirates
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-908">
                  <div className="bg-blue-100 p-3 rounded-lg mr-4" data-id="element-909">
                    <PhoneIcon className="h-6 w-6 text-[#2563EB]" data-id="element-910" />
                  </div>
                  <div data-id="element-911">
                    <h3 className="font-semibold text-lg mb-1" data-id="element-912">
                      Phone Support
                    </h3>
                    <p className="text-gray-600" data-id="element-913">+971 4 123 4567</p>
                    <p className="text-sm text-gray-500 mt-1" data-id="element-914">
                      Available 24/7 for customer support
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-915">
                  <div className="bg-blue-100 p-3 rounded-lg mr-4" data-id="element-916">
                    <MailIcon className="h-6 w-6 text-[#2563EB]" data-id="element-917" />
                  </div>
                  <div data-id="element-918">
                    <h3 className="font-semibold text-lg mb-1" data-id="element-919">Email Us</h3>
                    <p className="text-gray-600" data-id="element-920">support@travelsim.com</p>
                    <p className="text-sm text-gray-500 mt-1" data-id="element-921">
                      We'll respond within 24 hours
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-922">
                  <div className="bg-blue-100 p-3 rounded-lg mr-4" data-id="element-923">
                    <MessageCircleIcon className="h-6 w-6 text-[#2563EB]" data-id="element-924" />
                  </div>
                  <div data-id="element-925">
                    <h3 className="font-semibold text-lg mb-1" data-id="element-926">Live Chat</h3>
                    <p className="text-gray-600" data-id="element-927">Chat with our support team</p>
                    <p className="text-sm text-gray-500 mt-1" data-id="element-928">
                      Available 24/7 for instant support
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-8 pt-6 border-t border-gray-100" data-id="element-929">
                <h3 className="font-semibold text-lg mb-4" data-id="element-930">Follow Us</h3>
                <div className="flex space-x-4" data-id="element-931">
                  <a href="#" className="bg-gray-100 p-3 rounded-full hover:bg-blue-100 transition-colors" data-id="element-932">
                    <svg className="h-5 w-5 text-gray-700" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-933">
                      <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" data-id="element-934" />
                    </svg>
                  </a>
                  <a href="#" className="bg-gray-100 p-3 rounded-full hover:bg-blue-100 transition-colors" data-id="element-935">
                    <svg className="h-5 w-5 text-gray-700" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-936">
                      <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-937" />
                    </svg>
                  </a>
                  <a href="#" className="bg-gray-100 p-3 rounded-full hover:bg-blue-100 transition-colors" data-id="element-938">
                    <svg className="h-5 w-5 text-gray-700" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-939">
                      <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" data-id="element-940" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
          {/* Contact Form */}
          <div className="lg:col-span-2" data-id="element-941">
            <div className="bg-white rounded-xl shadow-sm p-8" data-id="element-942">
              <h2 className="text-2xl font-bold mb-6" data-id="element-943">Send Us a Message</h2>
              {isSubmitted ? <div className="flex flex-col items-center justify-center py-12" data-id="element-944">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4" data-id="element-945">
                    <CheckCircleIcon className="h-8 w-8 text-green-500" data-id="element-946" />
                  </div>
                  <h3 className="text-xl font-semibold mb-2" data-id="element-947">Message Sent!</h3>
                  <p className="text-gray-600 text-center mb-6" data-id="element-948">
                    Thank you for reaching out. We'll get back to you as soon as
                    possible.
                  </p>
                  <Button variant="primary" onClick={() => setIsSubmitted(false)} data-id="element-949">
                    Send Another Message
                  </Button>
                </div> : <form onSubmit={handleSubmit} data-id="element-950">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-951">
                    <div data-id="element-952">
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-953">
                        Your Name
                      </label>
                      <input type="text" id="name" name="name" value={formState.name} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="John Doe" required data-id="element-954" />
                    </div>
                    <div data-id="element-955">
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-956">
                        Email Address
                      </label>
                      <input type="email" id="email" name="email" value={formState.email} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="john@example.com" required data-id="element-957" />
                    </div>
                  </div>
                  <div className="mb-6" data-id="element-958">
                    <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-959">
                      Subject
                    </label>
                    <select id="subject" name="subject" value={formState.subject} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" required data-id="element-960">
                      <option value="" data-id="element-961">Select a subject</option>
                      <option value="general" data-id="element-962">General Inquiry</option>
                      <option value="support" data-id="element-963">Technical Support</option>
                      <option value="billing" data-id="element-964">Billing Question</option>
                      <option value="partnership" data-id="element-965">
                        Partnership Opportunity
                      </option>
                      <option value="feedback" data-id="element-966">Feedback</option>
                    </select>
                  </div>
                  <div className="mb-6" data-id="element-967">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-968">
                      Message
                    </label>
                    <textarea id="message" name="message" value={formState.message} onChange={handleChange} rows={6} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="How can we help you?" required data-id="element-969"></textarea>
                  </div>
                  <div className="flex items-center mb-6" data-id="element-970">
                    <input type="checkbox" id="privacy" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" required data-id="element-971" />
                    <label htmlFor="privacy" className="ml-2 block text-sm text-gray-700" data-id="element-972">
                      I agree to the{' '}
                      <a href="/terms-privacy" className="text-blue-600 hover:underline" data-id="element-973">
                        Privacy Policy
                      </a>{' '}
                      and consent to being contacted by email.
                    </label>
                  </div>
                  <Button type="submit" variant="primary" fullWidth data-id="element-974">
                    <SendIcon className="h-4 w-4 mr-2" data-id="element-975" />
                    Send Message
                  </Button>
                </form>}
            </div>
          </div>
        </div>
        {/* Map Section */}
        <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-16" data-id="element-976">
          <div className="aspect-w-16 aspect-h-7" data-id="element-977">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3609.9028426930216!2d55.2708583!3d25.2048493!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f43348a67e24b%3A0xff45e502e1ceb7e2!2sBurj%20Khalifa!5e0!3m2!1sen!2sae!4v1642777770962!5m2!1sen!2sae" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen loading="lazy" title="TravelSIM Office Location" data-id="element-978"></iframe>
          </div>
        </div>
        {/* FAQ Section */}
        <div className="text-center mb-8" data-id="element-979">
          <h2 className="text-2xl font-bold mb-2" data-id="element-980">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-600" data-id="element-981">
            Find quick answers to common questions or browse our full{' '}
            <a href="/help" className="text-blue-600 hover:underline" data-id="element-982">
              Help Center
            </a>
            .
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-983">
          <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-984">
            <h3 className="font-semibold text-lg mb-3" data-id="element-985">
              How quickly will you respond to my inquiry?
            </h3>
            <p className="text-gray-600" data-id="element-986">
              We aim to respond to all inquiries within 24 hours. For urgent
              matters, please use our live chat or call our support line for
              immediate assistance.
            </p>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-987">
            <h3 className="font-semibold text-lg mb-3" data-id="element-988">
              Can I get a refund if I haven't used my eSIM?
            </h3>
            <p className="text-gray-600" data-id="element-989">
              Yes, we offer full refunds for eSIMs that haven't been activated.
              Please check our{' '}
              <a href="/refund-policy" className="text-blue-600 hover:underline" data-id="element-990">
                Refund Policy
              </a>{' '}
              for details.
            </p>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-991">
            <h3 className="font-semibold text-lg mb-3" data-id="element-992">
              How do I activate my eSIM?
            </h3>
            <p className="text-gray-600" data-id="element-993">
              Activation is simple - scan the QR code we provide and follow the
              on-screen instructions. Visit our{' '}
              <a href="/installation-guide" className="text-blue-600 hover:underline" data-id="element-994">
                Installation Guide
              </a>{' '}
              for step-by-step help.
            </p>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-995">
            <h3 className="font-semibold text-lg mb-3" data-id="element-996">
              Do you offer business or group plans?
            </h3>
            <p className="text-gray-600" data-id="element-997">
              Yes, we offer special rates for businesses and groups. Please
              contact our sales team at sales@travelsim.com for customized
              solutions.
            </p>
          </div>
        </div>
      </div>
    </main>;
}